module.exports = __webpack_public_path__ + "img/logo.5386f627.png";